import { filterTree, processTree, } from '@algomusinc/services';
import * as lodash from 'lodash';
export const getCurrentWeekSelection = (calendarListDropdown: any, currentWeekId: any) => {

    const allNodes = lodash.cloneDeep(calendarListDropdown);
    const calendarProcessTree: any = processTree(allNodes);

    const allCalendarIds = calendarProcessTree
        .filter((row: any) => row.leaf)
        .map((row: any) => row.data.toString());

    const disabledTree = filterTree(allNodes, allCalendarIds, false, false, '');

    const allTreeNodes = lodash.cloneDeep(calendarListDropdown);
    let selectedTree = filterTree(allTreeNodes, currentWeekId, true, false, '')

    selectedTree = processTree(selectedTree)
    return {
        calendar: selectedTree,
        calendarListDropdown: disabledTree
    };
}

export function disableFutureWeeks(treeNodes: any[], currentWeekId: any): any[] {
    if (!treeNodes) return [];

    for (let treeNode of treeNodes) {
        // Disable leafs of future weeks
        if (treeNode.leaf && treeNode.data >= currentWeekId) {
            treeNode.selectable = false;
        }

        // Recursively process children
        if (!treeNode.leaf) {
            disableFutureWeeks(treeNode.children, currentWeekId);
            // To Disable the parent of all disabled weeks
            const allChildLeavesNotSelectable = treeNode.children
                .every((item: any) => !item.selectable);
            treeNode.selectable = !allChildLeavesNotSelectable;
        }
    }
    return treeNodes;
}